import { proxy, useSnapshot } from 'valtio';

interface UpNextStore {
  // Switching visible value triggers show/hide animation for overlay
  isOverlayVisible: boolean;
  // showControls is used to show/hide player controls when overlay visibility is switched
  // We cannot use visible prop alone because we have another variable which actually
  // puts the overlay into the DOM and removes it.
  showControls: boolean;
  // eventListeners array holds the event listener callback which are used to track clicking
  // outside of the up next items to be able to dismiss the overlay during playtime.
  // If the player reaches the end we don't want to allow dismissing it.
  eventListeners: (() => void)[];
  // If the value is true it means that an up next was triggered so we start the playback
  // from the beginning ignoring the resume point.
  startFromBeginning: boolean;
}

const defaultState: UpNextStore = {
  isOverlayVisible: true,
  eventListeners: [],
  showControls: true,
  startFromBeginning: false,
};

export const upNextStore = proxy<UpNextStore>(defaultState);

export const upNextStoreActions = {
  setOverlayVisibility(visible: boolean) {
    upNextStore.isOverlayVisible = visible;
    upNextStore.showControls = !visible;
  },
  setShowControls(show: boolean) {
    upNextStore.showControls = show;
  },
  setStartFromBeginning(startFromBeginning: boolean) {
    upNextStore.startFromBeginning = startFromBeginning;
  },
  addEventListener(callback: () => void) {
    upNextStore.eventListeners.push(callback);
  },
  clearEventListeners() {
    while (upNextStore.eventListeners.length) {
      const callback = upNextStore.eventListeners.pop();

      if (callback) {
        document.removeEventListener('click', callback);
      }
    }
  },
  reset() {
    upNextStoreActions.clearEventListeners();
    upNextStore.isOverlayVisible = defaultState.isOverlayVisible;
    upNextStore.eventListeners = defaultState.eventListeners;
    upNextStore.showControls = defaultState.showControls;
  },
};

export const useUpNextStore = () => useSnapshot(upNextStore) as UpNextStore;
